
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import DeactiveCustomer from "../components/deactivecustomer";
import Footer from "../components/footer";

function DeactiveCustomerPage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <DeactiveCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default DeactiveCustomerPage;